import React from "react";
import LoadDocument from "../thumbnail/loadDocument";
import useDownloader from "react-use-downloader";
import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined";
import FolderZipOutlinedIcon from "@mui/icons-material/FolderZipOutlined";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import { Backdrop, Grid } from "@mui/material";
import { CircularProgress } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import { column } from "stylis";
const DownloaderCmp = (props: any) => {
  const {
    size,
    elapsed,
    percentage,
    download,
    cancel,
    error,
    isInProgress,
  } = useDownloader();
  let typeFiles;
  let type;
  if (props.data.fileType == "Image") {
    typeFiles = (
      <img src={props.data.fileUrl} className='verticalImageContract' />
    );
    type = "jpg";
  } else if (props.data.fileType == "PDF" || props.data.fileType == "Any") {
    typeFiles = <PictureAsPdfOutlinedIcon className='uploadImageIcon ' />;
    type = "pdf";
  } else if (props.data.fileType == "ZIP" || props.data.fileType == "RAR") {
    typeFiles = <FolderZipOutlinedIcon className='uploadImageIcon ' />;
    type = "RAR";
  } else {
    typeFiles = <InsertDriveFileOutlinedIcon className='uploadImageIcon ' />;
    type = "jpg";
  }
  const fileUrl = props.data.fileUrl;
  const filename = `قرارداد.${type}`;
  const handleDownloda = () => {
    download(fileUrl, filename);
    window.open(fileUrl);
    // DownloadContractForSignMutation.mutate({
    //   referenceKey: "eb0f9ec5-3b23-4c1e-aed2-5ac1759586b9",
    // });
  };

  return (
    <>
      {/* <div
        className="row "
        style={{
          marginRight: props.marginRight ? props.marginRight : "2vh",
          marginLeft: props.marginLeft ? props.marginLeft : "-6vh",
          cursor: "pointer",
          height: "15vh",
        }}
        onClick={handleDownloda}
      > */}
      <Grid
        className=''
        container
        xs={12}
        spacing={1}
        // columns={{ xs: 2, sm: 8, md: 12 }}
        alignItems='center'
        justifyContent='center'
        style={{
          border: "3px dashed #dae0e4",
          cursor: "pointer",
          borderRadius: "5px",
        }}
        onClick={handleDownloda}
      >
        <Grid item xs={1}>
          <DownloadIcon style={{ color: "#01af43", marginBottom: "4em" }} />
        </Grid>
        <Grid item xs={10}>
          {props.data ? (
            <>
              {/* <DownloadIcon style={{ color: "#01af43", top: 0 }} /> */}
              <span>{typeFiles}</span>
              <span>
                {" "}
                {isInProgress ? (
                  <>
                    <Backdrop
                      hidden={false}
                      open={true}
                      sx={{ color: "#fff", zIndex: () => 1 }}
                    >
                      <CircularProgress color='inherit' />
                    </Backdrop>
                  </>
                ) : (
                  ""
                )}
              </span>
            </>
          ) : null}
        </Grid>
      </Grid>
      {/* </div> */}
    </>
  );
};

export default DownloaderCmp;
